import { useState, useEffect, useCallback } from 'react';
import type { users } from '@techgitter/contracts';
import { getUsers } from '../services/usersCacheService';

export function useUsers() {
  const [userList, setUserList] = useState<users[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    try {
      const result = await getUsers();
      setUserList(result.data);
    } catch (err: any) {
      setError(err.message || 'Failed to load users');
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return { users: userList, isLoading, error, reload: load };
}
